import { render, staticRenderFns } from "./contract-into-modal-new-instance.component.vue?vue&type=template&id=518d4760&scoped=true&"
import script from "./contract-into-modal-new-instance.component.vue?vue&type=script&lang=ts&"
export * from "./contract-into-modal-new-instance.component.vue?vue&type=script&lang=ts&"
import style0 from "./contract-into-modal-new-instance.component.vue?vue&type=style&index=0&id=518d4760&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518d4760",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VDatePicker,VDialog,VDivider,VForm,VMenu,VSwitch,VTextField})
